'use client';

import HeaderLogo from '@/assets/svg/HeaderLogo';
import Link from 'next/link';
import LangSelect from '@/components/layout/LangSelect';
import { Locale } from '@/enums/locale.enum';
import NavLinks from '@/components/layout/NavLinks';
import SideMenu from '@/components/layout/SideMenu';
import { usePathname } from 'next/navigation';
import { cn } from '@/lib/utils';

interface HeaderProps {
  headerText: any;
  navText: any;
  tags: any;
  lang: Locale;
  src: 'layout' | 'landing' | 'side' | 'header';
  sectionRef?: React.RefObject<HTMLElement>;
}

export default function Header(props: HeaderProps) {
  const pathname = usePathname();
  const { headerText, navText, lang, tags } = props;
  const { src } = props;

  const homepage = pathname.split('/').length === 2;

  const portfolioPage = /^\/[a-z]{2}\/portfolio\/[a-z0-9-]+$/.test(pathname);
  const projects =
    pathname.split('/').length === 3 && pathname.split('/')[2] === 'portfolio';
  const studioPage = /^\/[a-z]{2}\/studio\/[a-z0-9-]+$/.test(pathname);
  const studio =
    pathname.split('/').length === 3 && pathname.split('/')[2] === 'studio';
  const service = /^\/[a-z]{2}\/services$/.test(pathname);
  const privacy = /^\/[a-z]{2}\/privacy$/.test(pathname);
  const cookie = /^\/[a-z]{2}\/cookie-policy$/.test(pathname);
  const blog = /^\/[a-z]{2}\/blog$/.test(pathname);
  const blogPost = /^\/[a-z]{2}\/blog\/[a-z0-9-]+$/.test(pathname);
  const notFound = /^\/[a-z]{2}\/not-found$/.test(pathname);
  const joinTeam = /^\/[a-z]{2}\/join-the-team$/.test(pathname);
  const contact = /^\/[a-z]{2}\/contact$/.test(pathname);

  return (
    <header
      className={cn(
        'py-5 px-20 h-[96px] 2xl:pl-[160px] 2xl:pr-[160px] pl-[90px] pr-[90px]  bg-transparent sm:mt-10 sm:px-6 sm:py-12 absolute sm:relative text-white sm:mix-blend-difference lg:px-10 top-0 mt-0 w-full duration-smooth main-header',
        { hidden: homepage && src === 'layout' },
        { 'bg-transparent top-0 w-full': studioPage || studio },
        {
          '!text-[#101011] sm:mix-blend-normal':
            projects ||
            service ||
            blog ||
            notFound ||
            joinTeam ||
            contact ||
            cookie ||
            privacy,
        },
        {
          'sm:mt-0 sm:pt-[5.5rem] sm:!text-white sm:mix-blend-normal sm:bg-[#101011]':
            studio
        },
        {
          'sm:!text-[#101011] sm:mix-blend-normal':
            blogPost
        }
      )}
      style={{
        zIndex: 111,
        color: '#fff',
        height: 'auto',
      }}
    >
      <div>
        <div className='flex justify-between items-center'>
          <Link href='/'>
            <div className='w-[133px] h-[24px]'>
              <HeaderLogo
                className={cn('fill-white', {
                  '!fill-[#101011]':
                    projects ||
                    service ||
                    blog ||
                    notFound ||
                    joinTeam ||
                    privacy ||
                    cookie ||
                    contact,
                }, {
                  'sm:!fill-[#101011]': blogPost
                })}
              />
            </div>
          </Link>

          <div className='flex-grow flex justify-center'>
            <NavLinks
              lang={lang}
              text={navText}
              color={
                projects ||
                service ||
                blog ||
                privacy ||
                notFound ||
                joinTeam ||
                cookie ||
                contact
                  ? 'black'
                  : 'white'
              }
              component='header'
            />
          </div>

          <div className='items-center gap-2 flex sm:hidden'>
            <Link href='/contact'>
              <div
                className={cn(
                  'rounded-full text-[13px] leading-[120%] border-white text-white font-poppins py-1 px-5 border bg-transparent uppercase font-semibold',
                  {
                    'border-[#101011] text-[#101011]':
                      projects ||
                      service ||
                      blog ||
                      notFound ||
                      joinTeam ||
                      privacy ||
                      cookie ||
                      contact,
                  }
                )}
              >
                {headerText.contact}
              </div>
            </Link>
            <div>
              <LangSelect className='' src={src} lang={lang} />
            </div>
          </div>

          <div
            className='hidden sm:block ml-4'
            style={{
              zIndex: 999,
            }}
          >
            <SideMenu text={navText} tags={tags} lang={lang} />
          </div>
        </div>
      </div>
    </header>
  );
}
